export const PLAN_IDS = {
    FREE         : 'free',
    STARTER      : 'starter',
    BUSINESS     : 'business',
    BUSINESS_PRO : 'business-pro',
    ENTERPRISE   : 'enterprise',
} as const;

export type PlanId = typeof PLAN_IDS[keyof typeof PLAN_IDS];
